// Finds the student's course in the dashboard list cached in localStorage
// ("menteeData"). Batch entries carry the batch's id, not a course id, so they
// are only searched through their students; otherwise course 53 would match
// batch 53.
export function findMenteeCourse(id) {
  let parsed;
  try {
    parsed = JSON.parse(localStorage.getItem("menteeData"));
  } catch (error) {
    console.error("Error parsing course data:", error);
    return null;
  }
  if (!parsed) return null;
  const key = String(id);
  const items = Array.isArray(parsed) ? parsed : [parsed];

  const direct = items.find(
    (item) => item?.type !== "batch" && item?.id?.toString() === key
  );
  if (direct) return direct;

  for (const item of items) {
    if (item?.type !== "batch" || !Array.isArray(item.students)) continue;
    const student = item.students.find((s) => s.course_id?.toString() === key);
    if (student) {
      return {
        ...student,
        id: student.course_id,
        name: item.course_name,
        description: item.description || "",
        batch_type: item.batch_type,
      };
    }
  }
  return null;
}
